import React, { useState, useEffect, useContext, useRef } from 'react';

import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';

import Cognito from '../..//Amplify';
import PodeMorarLogo from '../../assets/novosicones/podemorarcinza.svg';
import Close from '../Reutilizaveis/CloseButton';
import Menu from '../Menu';
import Notificacoes from '../Notificacoes';
import NotificationErrorModal from '../Notificacoes/NotificationErrorModal';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

import { ReactComponent as Calendar } from '../../assets/calendar.svg';
import { ReactComponent as MenuIcon } from '../../assets/novosicones/menu/menu_black_24dp.svg';

import { ContextoListaApartamentos } from '../../Components/ApartamentList/contextoImoveis';
import { ContextNotificacoes } from '../../services/notificacoes';
import { ContextRenegociacao } from '../../services/renegociacao';
import { stopDatadogRum } from '../../DataDog/configs';
import NotificationsBell from '../NotificationsBell';

import './styles.scss';

const TopLeftMenu = ({ tema }) => {
  const [saudacao, setSaudacao] = useState(Date);

  const [notificationsModal, setNotificationsModal] = useState(false);

  const { setImovelAtual, setImovelSelecionado, setSelected } = useContext(
    ContextoListaApartamentos
  );

  const { notificationNotFoundError } = useContext(ContextNotificacoes);

  const { setModalInformativoRenegociacaoExibido } =
    useContext(ContextRenegociacao);

  const { signOut } = Cognito;

  const history = useHistory();

  const refTop = useRef(null);
  const executeScroll = () => refTop.current.scrollIntoView();

  useEffect(() => {
    let hora = new Date();
    setSaudacao(hora.getHours());
  }, []);

  useEffect(() => {
    if (notificationNotFoundError) {
      setNotificationsModal(false);
      executeScroll();
    }
  }, [notificationNotFoundError]);

  const btnSignOut = async () => {
    // estes set states são para garantir que ao logar com novo usuário
    // os novos dados vão ser carregados corretamente

    setImovelAtual('');
    setImovelSelecionado('');
    setSelected(false);
    await signOut();

    setModalInformativoRenegociacaoExibido(false);

    localStorage.removeItem('token');

    sessionStorage.removeItem('token');

    localStorage.removeItem('idTokenSens');

    sessionStorage.removeItem('idTokenSens');

    localStorage.removeItem('idtoken');

    sessionStorage.removeItem('idtoken');

    localStorage.removeItem('imoveis');

    sessionStorage.removeItem('qtdAgdm');

    sessionStorage.removeItem('imovelAtual');

    localStorage.removeItem('tempToken');

    sessionStorage.removeItem('notifications');

    stopDatadogRum();
    history.push('/');
  };

  let saudacaoCliente = '';
  if (saudacao > '00' && saudacao < '12') {
    saudacaoCliente = (
      <span
        style={{ color: tema.primaryColor, transition: '0.3s' }}
        className='menu-top-left__btns__salutation'
      >
        Bom dia!
      </span>
    );
  } else if (saudacao >= '12' && saudacao < '18') {
    saudacaoCliente = (
      <span
        style={{ color: tema.primaryColor, transition: '0.3s' }}
        className='menu-top-left__btns__salutation'
      >
        Boa tarde!
      </span>
    );
  } else {
    saudacaoCliente = (
      <span
        style={{ color: tema.primaryColor, transition: '0.3s' }}
        className='menu-top-left__btns__salutation'
      >
        Boa noite!
      </span>
    );
  }

  window.addEventListener(
    'beforeunload',
    function () {
      localStorage.removeItem('tempToken');
    },
    false
  );

  return (
    <div className='centralized-column'>
      <div className='menu-top-left  centralized' ref={refTop}>
        <>
          {notificationsModal && (
            <div className='centralized'>
              <div className='menu-top-left__inner__btns__notifications__modal'>
                <Notificacoes
                  tema={tema}
                  setNotificationsModal={setNotificationsModal}
                />
              </div>
            </div>
          )}
          <div className='menuMobile'>
            <span
              className='menuMobile__closeMenu'
              onClick={() => {
                document
                  .getElementsByClassName('menuMobile')[0]
                  ?.classList.remove('menuMobile--showMenu');
              }}
              id='btnFecharModalNotificacoes'
            >
              <Close tamanho={'40px'} />
            </span>
            <Menu tema={tema} responsivo={true} />
          </div>
          <div className='centralized menu-top-left__inner'>
            {/* logo */}
            <div className='menu-top-left__inner__logo'>
              <Link to='/interna'>
                <img src={PodeMorarLogo} alt='' />
              </Link>
            </div>

            <div className='menu-top-left__inner__btns centralized-space-between'>
              {/* menu mobile*/}
              <span
                onClick={() => {
                  document
                    .getElementsByClassName('menuMobile')[0]
                    ?.classList.add('menuMobile--showMenu');
                }}
                className='menu-top-left__inner__btns__openMenuMobile'
              >
                <MenuIcon style={{ fill: tema.primaryColor, height: '24px' }} />
              </span>
              {/* saudação clientes */}
              <span className='menu-top-left__inner__btns__salutation'>
                {saudacaoCliente}
              </span>

              {/* notiicações */}

              <NotificationsBell
                primaryColor={tema.primaryColor}
                notificationsModal={notificationsModal}
                setNotificationsModal={setNotificationsModal}
                // newNotif={newNotif}
              />

              {/* agendamentos */}
              {sessionStorage.getItem('qtdAgdm') > 0 ? (
                <Link
                  to='/solicitacoes/calendario'
                  className='menu-top-left__inner__btns__agendamentos centralized'
                >
                  <Calendar fill={tema.primaryColor} />
                  <span
                    className='menu-top-left__inner__btns__agendamentos__qtd centralized'
                    style={{ backgroundColor: '#BA122B' }}
                  >
                    i
                  </span>
                </Link>
              ) : (
                <div className='menu-top-left__inner__btns__agendamentos centralized'>
                  <Calendar fill='#D1D1D1' />
                </div>
              )}
              <button
                id='btnSignOut'
                className='centralized menu-top-left__inner__btns__btnSignOut'
                onClick={() => btnSignOut()}
                style={{ color: tema.primaryColor }}
              >
                <span>Sair</span>
                <ExitToAppIcon />
              </button>
            </div>
          </div>
        </>
      </div>
      {notificationNotFoundError && <NotificationErrorModal />}
    </div>
  );
};

export default TopLeftMenu;
